<template>
  <div>
    <div class="row">
      <div class="col-md-12 col-lg-12">
        <v-row class="mb-5">
          <Tools
            :tagNova="tagNova"
            :tags="tags"
            @visivel="modalVisivel = true"
            @selecionar="tagSelecionada = $event"
          />
        </v-row>
        <v-row class="mb-5">
          <Templates
            :tag="tagSelecionada"
            :conteudo.sync="conteudoInicial"
            @content="conteudo"
            @limpar="tagSelecionada = null"
          />
        </v-row>
        <v-row>
          <v-divider></v-divider>
        </v-row>
        <v-row>
          <p>
            <v-btn @click="voltar" color="error" large>Voltar</v-btn>
            <!-- <v-btn
              @click="salvar()"
              color="primary"
              large
              class="ml-2"
              :disabled="saving"
              >Salvar</v-btn
            > -->
          </p>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "@/common/services/http/api.service";
import SweetAlert from "@/common/services/sweetalert.service";
import Templates from "@/views/components/EditorHtml/template/template.vue";
import Tools from "@/views/components/EditorHtml/tags/tools.vue";

export default {
  components: { Templates, Tools },
  data: () => ({
    modalVisivel: false,
    tagNova: null,
    tagSelecionada: null,
    saving: false,
    tags: [],
    conteudoInicial: "",
    grupo: {
      htmlNotification: "",
      grupoPropriedade: [],
    },
    prop: [],
  }),
  methods: {
    conteudo(texto) {
      this.salvar(texto);
    },
    async buscarGrupo(id) {
      const { data: result } = await ApiService.get("grupo/" + id);
      if (result.success) {
        this.grupo = result.data;
        this.conteudoInicial = this.grupo.htmlNotification;
        this.grupo.grupoPropriedade.push({ id: -1, nome: "LOGO" });
        this.grupo.grupoPropriedade.push({ id: -2, nome: "RELATÓRIO" });
        this.grupo.grupoPropriedade.push({ id: -3, nome: "DATA" });
        this.grupo.grupoPropriedade.push({ id: -3, nome: "DATA COMPLETA" });
        this.tags = this.grupo.grupoPropriedade.map((x) => ({
          id: x.id,
          nome: x.nome,
          valor: `{${x.nome}}`,
        }));
      } else SweetAlert.sweetAlertError(result.errors);
    },
    voltar() {
      this.$router.push({ name: "grupo" });
    },
    async salvar(html = null) {
      html = html ? html : this.conteudoInicial;
      const { data: result } = await ApiService.put(`grupo/updateNotificacao`, {
        html: html,
        grupoID: this.grupo.id,
      });
      if (result.success) {
        this.$router.push({ name: "grupo" });
      } else SweetAlert.sweetAlertError(result.errors);
    },
  },
  async mounted() {
    this.cliente = JSON.parse(window.localStorage.getItem("cliente"));

    if (this.$route.params.id !== undefined)
      await this.buscarGrupo(this.$route.params.id);
  },
};
</script>
